import { api } from '@/api'
import { setFavorites } from '@/modules/favorites-tank/store/favoritesSlise'
import {
  FavoritesRes,
  FavoritesSmallRes,
} from '@/modules/favorites-tank/types/favorites'
import { ISimpleResponse } from '@/modules/login/types'

const favoritesService = api.injectEndpoints({
  endpoints: (build) => ({
    getFavoritesWithDevicesAqua: build.query<FavoritesRes, void>({
      query: () => ({
        url: '/favorites/getWithDevices',
        method: 'GET',
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setFavorites(data.data))
        } catch (error) {}
      },
      providesTags: ['FavoritesAqua'],
    }),
    getFavoritesSmallAqua: build.query<FavoritesSmallRes, void>({
      query: () => ({
        url: '/favorites/get',
        method: 'GET',
      }),
      providesTags: ['FavoritesSmallAqua'],
    }),
    addFavoritesAqua: build.mutation<ISimpleResponse, FormData>({
      query: (body) => ({
        url: '/favorites/update',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['FavoritesSmallAqua', 'FavoritesAqua'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetFavoritesWithDevicesAquaQuery,
  useGetFavoritesSmallAquaQuery,
  useAddFavoritesAquaMutation,
} = favoritesService
